import classnames from "classnames";

import "./productLabel.scss";

export type ProductLabelProps = {
    text: string;
    secondary?: string;
    size?: "md" | "sm" | "xs";
};

const ProductLabel = ({ text, secondary, size = "md" }: ProductLabelProps) => (
    <span
        className={classnames(
            "product-label",
            secondary && "product-label__secondary",
            size === "sm" && "product-label--small",
            size === "xs" && "product-label--extra-small"
        )}
    >
        <span className={classnames("text", size === "md" ? "p-2" : "p-1")}>
            {text}
        </span>
        {secondary && (
            <span
                className={classnames(
                    "secondary",
                    size === "md" ? "p-2" : "p-1"
                )}
            >
                {secondary}
            </span>
        )}
    </span>
);

export { ProductLabel };
